import { render } from "./MigrateData.vue?vue&type=template&id=76540715&scoped=true"
import script from "./MigrateData.vue?vue&type=script&lang=js"
export * from "./MigrateData.vue?vue&type=script&lang=js"

import "./MigrateData.vue?vue&type=style&index=0&id=76540715&lang=scss&scoped=true"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76540715"]])

export default __exports__